export class ContainerService {
    get(_key) {
        throw new Error('ContainerService "get" method must be implemented');
    }
    registerInstance(_key, _instance) {
        throw new Error('ContainerService "registerInstance" method must be implemented');
    }
}
//# sourceMappingURL=container.service.js.map